import { ProductEnum } from "./login";

/** Spa Retail Items Setup — Item Type options (Excel numeric codes). */
export const SPA_RETAIL_ITEM_TYPES = [
  { label: "Spa Services", value: 3 },
  { label: "Spa Package", value: 4 },
  { label: "Appointment Addon", value: 5 },
] as const;

/** Golf Retail Items Setup — Item Type options. */
export const GOLF_RETAIL_ITEM_TYPES = [
  { label: "Deposit", value: 6 },
  { label: "Caddy Fee", value: 9 },
] as const;

/** SnC Retail Items Setup — Item Type options. */
export const SNC_RETAIL_ITEM_TYPES = [
  { label: "Deposit", value: 6 },
  { label: "Revenue Item", value: 1 },
] as const;

export type RetailItemTypeOption = {
  label: string;
  value: number;
};

/** @deprecated Use SPA_RETAIL_ITEM_TYPES or getRetailItemTypes() */
export const RETAIL_ITEM_TYPES = SPA_RETAIL_ITEM_TYPES;

export const getRetailItemTypes = (
  productType?: ProductEnum | string | null,
): RetailItemTypeOption[] => {
  if (productType === ProductEnum.GOLF) {
    return [...GOLF_RETAIL_ITEM_TYPES];
  }
  if (productType === ProductEnum.SALES_AND_CATETING) {
    return [...SNC_RETAIL_ITEM_TYPES];
  }
  return [...SPA_RETAIL_ITEM_TYPES];
};

export const getRetailItemTypeLabels = (
  productType?: ProductEnum | string | null,
): string[] => getRetailItemTypes(productType).map((item) => item.label);

export const getRetailItemTypeValue = (
  label: string | null | undefined,
  productType?: ProductEnum | string | null,
): number | undefined => {
  if (!label) return undefined;
  const match = getRetailItemTypes(productType).find(
    (item) => item.label === label,
  );
  return match?.value;
};

export const getRetailItemTypeLabel = (
  value: number | string | null | undefined,
  productType?: ProductEnum | string | null,
): string | null => {
  if (value === null || value === undefined || value === "") return null;
  const types = getRetailItemTypes(productType);
  const numeric = Number(value);
  if (!Number.isNaN(numeric)) {
    const byValue = types.find((item) => item.value === numeric);
    if (byValue) return byValue.label;
  }
  const byLabel = types.find((item) => item.label === String(value));
  return byLabel?.label ?? null;
};
